const loadRazorpayCheckout = () => new Promise((resolve, reject) => {
  if (window.Razorpay) return resolve();
  const script = document.createElement("script");
  script.src = "https://checkout.razorpay.com/v1/checkout.js";
  script.async = true;
  script.onload = resolve;
  script.onerror = () => reject(new Error("Unable to load secure checkout."));
  document.body.appendChild(script);
});

export const openRazorpayCheckout = async ({ order, verify }) => {
  await loadRazorpayCheckout();
  return new Promise((resolve, reject) => {
    const checkout = new window.Razorpay({
      key: order.key_id, order_id: order.order_id, amount: order.amount, currency: order.currency,
      name: "Bettercorporatelife", description: order.description,
      prefill: { name: order.name || "", email: order.email || "", contact: order.contact || "" },
      handler: async (response) => {
        try { resolve(await verify(response)); } catch (error) { reject(error); }
      },
      modal: { ondismiss: () => reject(new Error("Checkout was closed before payment.")) },
      retry: { enabled: true },
    });
    checkout.open();
  });
};
